/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Plan_Change_TitleInputs */

const fr_membership_plan_change_title = /** @type {(inputs: Membership_Plan_Change_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changer de formule`)
};

/**

* @param {Membership_Plan_Change_TitleInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_plan_change_title = /** @type {((inputs?: Membership_Plan_Change_TitleInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Plan_Change_TitleInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_plan_change_title(inputs)
});